import { render, staticRenderFns } from "./AdvancedUiSetting.vue?vue&type=template&id=3259fd78"
import script from "./AdvancedUiSetting.vue?vue&type=script&lang=ts"
export * from "./AdvancedUiSetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports